import "../../utils/tailwind.css";
import { PageProvider, usePageProvider } from "./provider";
import Section from "../../components/section";

import { Accordion } from "react-bootstrap";
import { Formik, Form, FieldArray } from "formik";
import { FormikInput } from "../../components/input";
import Plus from "../../components/svg/plus";
import Label from "../../components/label";
import Trash from "../../components/svg/trash";
import ImageUploader from "../../components/upload-image";
import Button from "../../components/Buttons";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const {
    initialValues,
    handleClientAdd,
    clientListArray,
    handleClientDelete,
    handlePartnershipImageAdd,
    ourPartnershipImageArray,
    handlePartnershipImageDelete,
    industriesListArray,
    handleIndustriesAdd,
    handleTechnologyAdd,
    technologyListArray,
    handleIndustriesDelete,
    handleTechnologyDelete,
    handleSubmit,
    handleCreativesAdd,
    handleCreativesDelete,
    creativesListArray,
    handleSpotlightAdd,
    handleSpotlightDelete,
    spotilightListArray,
  } = usePageProvider();

  return (
    <Section>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize>
        {({ values, setFieldValue }) => (
          <Form>
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="1">
                <Accordion.Header>SEO Meta</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Meta Title"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.meta_title"
                        rootClassName="w-full"
                      />
                    </div>
                    
                    <div className="flex flex-col">
                      <Label
                        label="Meta Keywords"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.keywords"
                        rootClassName="w-full"
                        as="textarea"
                        className="h-[26rem]"
                      />
                    </div>
                    <div className="flex flex-col ">
                      <Label
                        label="Meta Description"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="meta.meta_description"
                        rootClassName="w-full"
                        as="textarea"
                        className="h-[26rem]"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>Banner</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Title"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.sub_heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="CTA"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.cta_label"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="CTA Redirect Link"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.cta_label_redirect_link"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-1 gap-3 mt-3 ">
                    <div className="flex flex-col">
                      <Label
                        label="Description"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="banner.description"
                        rootClassName="w-full"
                        as="textarea"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3 mt-3 ">
                    <div className="flex flex-col">
                      <Label
                        label="Blogs Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="insights_heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="Work Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="works_heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="Testimonial Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="testimonial_heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>Creatives</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="creative.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="Description"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="creative.sub_heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>

                  <div className="flex justify-end">
                    <div className=" mt-3 bg-[black] p-1 rounded-full w-auto  cursor-pointer">
                      <Plus
                        onClick={handleCreativesAdd}
                        className={" text-[white]"}
                      />
                    </div>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Image
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Heading
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Description
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Redirect Link
                          </th>
                          {values?.creative?.creativeList?.length > 0 && (
                            <th className="border font-normal border-gray-300 px-1 text-center">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="creative.creativeList"
                          render={(arrayHelper) => {
                            creativesListArray.current = arrayHelper;
                            return (
                              <>
                                {values?.creative?.creativeList?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="border border-gray-300 px-2 py-2">
                                        <ImageUploader
                                          imgStyle={{ width: "8rem" }}
                                          imageUrl={
                                            values?.creative?.creativeList?.[index]?.image
                                          }
                                          onChange={(res) => {
                                            setFieldValue(
                                              `creative.creativeList.${index}.image`,
                                              res?.data?.file_url
                                            );
                                          }}
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-2 py-2">
                                        <FormikInput
                                          name={`creative.creativeList.${index}.title`}
                                          rootClassName="w-full"
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-4 py-2">
                                        <FormikInput
                                          name={`creative.creativeList.${index}.description`}
                                          rootClassName="w-full"
                                          as="textarea"
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-4 py-2">
                                        <FormikInput
                                          name={`creative.creativeList.${index}.redirect_link`}
                                          rootClassName="w-full"
                                        />
                                      </td>
                                      {values?.creative?.creativeList?.length >
                                        0 && (
                                        <td
                                          className="border border-gray-300 bg-white px-4 py-2 cursor-pointer text-center "
                                          onClick={handleCreativesDelete(
                                            index
                                          )}>
                                          <Trash className="mx-auto" />
                                        </td>
                                      )}
                                    </tr>
                                  )
                                )}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>Clients</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3 mb-3">
                    <div className="flex flex-col">
                      <Label
                        label="Client Marquee Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="client.client_heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <div className=" bg-[black] p-1 rounded-full w-auto cursor-pointer ">
                      <Plus
                        onClick={handleClientAdd}
                        className={" text-[white]"}
                      />
                    </div>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left  ">
                            Image
                          </th>
                          {values?.clientList?.length > 0 && (
                            <th className="border font-normal border-gray-300 px-2 py-2 text-center">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="client.clientList"
                          render={(arrayHelper) => {
                            clientListArray.current = arrayHelper;
                            return (
                              <>
                                {values?.client?.clientList?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="border border-gray-300 px-4 py-2  ">
                                        <ImageUploader
                                        imgStyle={{ width: "8rem" }}
                                          imageUrl={
                                            values?.client?.clientList?.[index]
                                              ?.image_url
                                          }
                                          onChange={(res) => {
                                            setFieldValue(
                                              `client.clientList.${index}.image_url`,
                                              res?.data?.file_url
                                            );
                                          }}
                                        />
                                      </td>
                                      {values?.client?.clientList?.length >
                                        0 && (
                                        <td
                                          className="flex justify-center py-3 cursor-pointer"
                                          onClick={handleClientDelete(index)}>
                                          <Trash />
                                        </td>
                                      )}
                                    </tr>
                                  )
                                )}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>Our Partnership</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="our_partnership.heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="flex justify-end ">
                    <div className=" mt-3 bg-[black] p-1 rounded-full w-auto  cursor-pointer">
                      <Plus
                        onClick={handlePartnershipImageAdd}
                        className={" text-[white]"}
                      />
                    </div>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left w-1/2">
                            Banner Image
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left w-1/2">
                            CTA Link
                          </th>
                          {values?.our_partnership?.our_partnership_image
                            ?.length > 0 && (
                            <th className="border font-normal border-gray-300 px-4 py-2 text-center w-[10%]">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="our_partnership.our_partnership_image"
                          render={(arrayHelper) => {
                            ourPartnershipImageArray.current = arrayHelper;

                            return (
                              <>
                                {values?.our_partnership?.our_partnership_image?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="border border-gray-300 px-2 py-2 w-1/2">
                                        <ImageUploader
                                        imgStyle={{ width: "10rem" }}
                                          imageUrl={
                                            values?.our_partnership
                                              ?.our_partnership_image?.[index]
                                              ?.image_link
                                          }
                                          onChange={(res) => {
                                            setFieldValue(
                                              `our_partnership.our_partnership_image.${index}.image_link`,
                                              res?.data?.file_url
                                            );
                                          }}
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-2 w-1/2">
                                        <FormikInput
                                          name={`our_partnership.our_partnership_image.${index}.cta_link`}
                                          rootClassName="w-full"
                                        />
                                      </td>
                                      {values?.our_partnership
                                        ?.our_partnership_image?.length > 0 && (
                                        <td className="border border-gray-300 w-[10%] text-center">
                                          <button
                                            type="button"
                                            className="flex justify-center items-center w-full h-full py-2"
                                            onClick={handlePartnershipImageDelete(
                                              index
                                            )}>
                                            <Trash />
                                          </button>
                                        </td>
                                      )}
                                    </tr>
                                  )
                                )}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>Industries</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="industries.heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div className="flex justify-end  ">
                    <div className=" mt-3 bg-[black] p-1 rounded-full w-auto cursor-pointer ">
                      <Plus
                        onClick={handleIndustriesAdd}
                        className={" text-[white]"}
                      />
                    </div>
                  </div>

                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left w-[90%]">
                            Title
                          </th>
                          {values?.industries?.industriesList?.length > 0 && (
                            <th className="border font-normal border-gray-300 px-1 text-center w-[10%]">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="industries.industriesList"
                          render={(arrayHelper) => {
                            industriesListArray.current = arrayHelper;
                            return (
                              <>
                                {values?.industries.industriesList?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="border border-gray-300 px-4 py-2 w-[90%]">
                                        <FormikInput
                                          name={`industries.industriesList.${index}.title`}
                                          rootClassName="w-full"
                                        />
                                      </td>
                                      {values?.industries.industriesList
                                        ?.length > 0 && (
                                        <td
                                          className="border border-gray-300 bg-white px-2 py-2 cursor-pointer w-[10%]"
                                          onClick={handleIndustriesDelete(
                                            index
                                          )}>
                                          <div className="flex justify-center">
                                            <Trash />
                                          </div>
                                        </td>
                                      )}
                                    </tr>
                                  )
                                )}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>Spotlight</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="spotlight_details.heading"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="SubHeading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="spotlight_details.sub_heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div
                    className="flex justify-end"
                   >
                    <div className=" mt-3 bg-[black] p-1 rounded-full w-auto cursor-pointer">
                      <Plus  onClick={handleSpotlightAdd} className={" text-[white]"} />
                    </div>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Title
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            CTA
                          </th>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Logo
                          </th>
                          {values?.spotlight_details.spotlights?.length > 0 && (
                            <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="spotlight_details.spotlights"
                          render={(arrayHelper) => {
                            spotilightListArray.current = arrayHelper;
                            return (
                              <>
                                {values?.spotlight_details.spotlights?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td className="border border-gray-300 px-2 py-2">
                                        <FormikInput
                                          name={`spotlight_details.spotlights.${index}.title`}
                                          rootClassName="w-full"
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-4 py-2">
                                        <FormikInput
                                          name={`spotlight_details.spotlights.${index}.cta`}
                                          rootClassName="w-full"
                                        />
                                      </td>
                                      <td className="border border-gray-300 px-4 py-2">
                                        <ImageUploader
                                        imgStyle={{ width: "10rem" }}
                                          imageUrl={
                                            values?.spotlight_details
                                              ?.spotlights?.[index]?.logo
                                          }
                                          onChange={(res) => {
                                            setFieldValue(
                                              `spotlight_details.spotlights.${index}.logo`,
                                              res?.data?.file_url
                                            );
                                          }}
                                        />
                                      </td>
                                      {values?.spotlight_details?.spotlights
                                        ?.length > 0 && (
                                        <td
                                          className="border border-gray-300 bg-white px-4 py-2 cursor-pointer text-center"
                                          onClick={handleSpotlightDelete(
                                            index
                                          )}>
                                          <Trash className="mx-auto" />
                                        </td>
                                      )}
                                    </tr>
                                  )
                                )}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300"></table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>Technology</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-1 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="technology.heading"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                  <div
                    className="flex justify-end  "
                  >
                    <div className=" mt-3 bg-[black] p-1 rounded-full w-auto cursor-pointer">
                      <Plus   onClick={handleTechnologyAdd} className={" text-[white]"} />
                    </div>
                  </div>
                  <div className="mt-3 overflow-x-auto">
                    <table className="w-full border-collapse border border-gray-300">
                      <thead className="bg-gray-200">
                        <tr>
                          <th className="border font-normal border-gray-300 px-4 py-2 text-left">
                            Title
                          </th>

                          {values?.technologyList?.length > 0 && (
                            <th className="border font-normal border-gray-300 px-2 py-2 text-center">
                              Action
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <FieldArray
                          name="technologyList"
                          render={(arrayHelper) => {
                            technologyListArray.current = arrayHelper;
                            return (
                              <>
                                {values?.technologyList?.map((item, index) => (
                                  <tr key={index}>
                                    <td className="border border-gray-300 px-2 py-2 w-[90%]">
                                      <Label className="mb-2 text-black text-[15px]" />
                                      <FormikInput
                                        name={`technologyList.${index}.title`}
                                        rootClassName="w-full"
                                      />
                                    </td>
                                    {values?.technologyList?.length > 0 && (
                                      <td className="border border-gray-300 w-[10%] text-center">
                                        <button
                                          type="button"
                                          className="flex justify-center items-center w-full h-full py-2"
                                          onClick={handleTechnologyDelete(
                                            index
                                          )}>
                                          <Trash />
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                ))}
                              </>
                            );
                          }}
                        />
                      </tbody>
                    </table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9" className="mb-10">
                <Accordion.Header>Brochure</Accordion.Header>
                <Accordion.Body>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3">
                    <div className="flex flex-col">
                      <Label
                        label="Heading"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="brochure_download.title"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="File"
                        className="mb-2 text-black text-[15px]"
                      />
                      <ImageUploader
                        className="w-full"
                        title="File"
                        name="brochure_download.file"
                        imageUrl={values?.brochure_download?.file}
                        onChange={(res) => {
                          setFieldValue(
                            `brochure_download.file`,
                            res?.data?.file_url
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-2 gap-3 mt-3">
                    <div className="flex flex-col">
                      <Label
                        label="Book a Demo Title"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="book_a_demo.title"
                        rootClassName="w-full"
                      />
                    </div>
                    <div className="flex flex-col">
                      <Label
                        label="Book a Demo Link"
                        className="mb-2 text-black text-[15px]"
                      />
                      <FormikInput
                        name="book_a_demo.link"
                        rootClassName="w-full"
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <div className="fixed bottom-0  left-0 w-full bg-white flex justify-end items-center py-3 rounded-lg pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
